import { useEffect, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useIntl } from '@zenbusiness/application-commons-intl';

import { AiSlideIn } from '#client/components/AiSlideIn';
import { SLIDE_IN_PANEL_PARAM_KEY } from '#client/pages/Home/constants';

import { SLIDE_CONFIGS } from './slideConfigs';

function SlideInPanelHandler() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [openSlides, setOpenSlides] = useState({});
  const { businessEntity } = useBusinessEntity();
  const { formatMessage } = useIntl();

  const slideParam = searchParams.get(SLIDE_IN_PANEL_PARAM_KEY);

  useEffect(() => {
    if (slideParam && SLIDE_CONFIGS[slideParam]) {
      const config = SLIDE_CONFIGS[slideParam];

      setOpenSlides((prev) => ({
        ...prev,
        [config.id]: true
      }));

      // Remove the sip parameter from URL after opening the slide
      setSearchParams((params) => {
        params.delete(SLIDE_IN_PANEL_PARAM_KEY);
        return params;
      });
    }
  }, [slideParam, businessEntity?.domesticJurisdiction, setSearchParams]);

  const handleCloseSlide = (slideType) => {
    setOpenSlides((prev) => ({
      ...prev,
      [slideType]: false
    }));
  };

  // Render slides based on configuration
  const renderSlides = () => Object.values(SLIDE_CONFIGS).map((config) => {
    const isOpen = !!openSlides[config.id];

    if (!isOpen) return null;

    if (config.component === 'ai') {
      const { aiConfig } = config;
      const businessEntityType = businessEntity?.businessEntityType || 'llc';
      const subtitleKey = aiConfig.subtitleKeys[businessEntityType] || aiConfig.subtitleKeys.llc;

      return (
        <AiSlideIn
          key={config.id}
          aiSlideInOpen={isOpen}
          closeHandler={() => handleCloseSlide(config.id)}
          title={formatMessage({ id: aiConfig.titleKey })}
          overline={formatMessage({ id: aiConfig.overlineKey })}
          subtitle={formatMessage({ id: subtitleKey })}
          promptSlug={aiConfig.promptSlug}
          queryType={aiConfig.queryType}
          fillData={{
            business_name: businessEntity?.name,
            location: businessEntity?.domesticJurisdiction,
            business_type: businessEntity?.businessEntityType
          }}
          eventingProperties={aiConfig.eventingProperties}
          errorMessage={formatMessage({ id: aiConfig.errorKey })}
          banner={{
            title: formatMessage({ id: aiConfig.banner.titleKey }),
            description: formatMessage({ id: aiConfig.banner.descriptionKey }),
            ctaText: formatMessage({ id: aiConfig.banner.ctaTextKey }),
            onCtaClick: () => aiConfig.banner.onCtaClick(
              businessEntity,
              handleCloseSlide,
              config.id
            )
          }}
        />
      );
    }

    return null;
  });

  return <>{renderSlides()}</>;
}

export default SlideInPanelHandler;
